import React from 'react'
import Gallery from '../components/gallery/Gallery'
export default function GalleryPage() {
  return (
    <div>
        <Gallery/>
    </div>
  )
}
